/**
 * 分类资源路由
 * 2017-11-22
 * Bai.Zhiming
 */
'use strict';
angular.module('classifiedResourceRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.networksource.classifiedresource.digital', {
                // 数字报
                url: '/digital',
                views: {
                    'main@front.networksource.classifiedresource': {
                        templateUrl: './networkResource/networksource_main_tpl.html',
                    },
                },
            })
            .state('front.networksource.classifiedresource.app', {
                // app
                url: '/app',
                views: {
                    'main@front.networksource.classifiedresource': {
                        templateUrl: './networkResource/networksource_main_tpl.html',
                    },
                },
            })
            .state('front.networksource.classifiedresource.website', {
                // 网站
                url: '/website',
                views: {
                    'main@front.networksource.classifiedresource': {
                        templateUrl: './networkResource/networksource_main_tpl.html',
                    },
                },
            })
            .state('front.networksource.classifiedresource.wechat', {
                // 微信
                url: '/wechat',
                views: {
                    'main@front.networksource.classifiedresource': {
                        templateUrl: './networkResource/networksource_main_tpl.html',
                    },
                },
            })
            .state('front.networksource.classifiedresource.weibo', {
                // 微博
                url: '/weibo',
                views: {
                    'main@front.networksource.classifiedresource': {
                        templateUrl: './networkResource/networksource_main_tpl.html',
                    },
                },
            })
            .state('front.networksource.classifiedresource.video', {
                // 视频
                url: '/video',
                views: {
                    'main@front.networksource.classifiedresource': {
                        templateUrl: './networkResource/networksource_main_tpl.html',
                    },
                },
            })
            .state('front.networksource.classifiedresource.picture', {
                // 图片
                url: '/picture',
                views: {
                    'main@front.networksource.classifiedresource': {
                        templateUrl: './networkResource/networksource_main_tpl.html',
                    },
                },
            });
    },
]);
